export const formatCurrency = (value: number) => {
	return value.toLocaleString('en-US', {
		maximumFractionDigits: 2,
		minimumFractionDigits: 2,
		style: 'currency',
		currency: 'USD',
	});
};
